import React, { useState, memo } from 'react';
import { ChevronDown, BookOpen } from 'lucide-react';
interface Chapter {
  title: string;
  content: string[];
}
interface Tomo {
  title: string;
  chapters: Chapter[];
}
const tomosData: Tomo[] = [{
  title: 'CAPÍTULO 1 — Instrumental Quirúrgico Explicado de Forma Visual',
  chapters: [{
    title: 'CAPÍTULO 1 — Introducción al instrumental quirúrgico',
    content: ['Qué hace realmente un instrumentador', 'Función del instrumental en cirugía', 'Cómo se clasifica el instrumental', 'Diferencia entre instrumental básico y especializado', 'Cómo reconocer instrumental rápidamente', 'Errores comunes de estudiantes', 'Cómo estudiar instrumental sin memorizar de forma caótica']
  }, {
    title: 'CAPÍTULO 2 — Instrumental de corte y disección',
    content: ['Bisturíes y mangos', 'Tipos de hojas', 'Tijeras Mayo', 'Tijeras Metzenbaum', 'Tijeras rectas vs curvas', 'Cómo identificar cada una', 'Usos correctos e incorrectos', 'Cuándo se usa cada instrumento']
  }, {
    title: 'CAPÍTULO 3 — Instrumental de prensión',
    content: ['Pinza Allis', 'Pinza Kocher', 'Pinza Foerster', 'Pinza Adson', 'Pinza anatómica', 'Pinza quirúrgica', 'Diferencias funcionales', 'Cómo pasarlas correctamente']
  }, {
    title: 'CAPÍTULO 4 — Instrumental de hemostasia',
    content: ['Mosquito', 'Kelly', 'Crile', 'Rochester', 'Cómo diferenciarlas rápidamente', 'Hemostasia básica', 'Función en distintos tipos de cirugía']
  }, {
    title: 'CAPÍTULO 5 — Separadores quirúrgicos',
    content: ['Separadores manuales', 'Separadores automáticos', 'Farabeuf', 'Richardson', 'Balfour', 'Finochietto', 'Uso correcto según profundidad quirúrgica']
  }, {
    title: 'CAPÍTULO 6 — Instrumental de sutura',
    content: ['Portaagujas', 'Tipos de agujas', 'Tipos de suturas', 'Material absorbible y no absorbible', 'Cómo preparar mesa de sutura', 'Errores frecuentes']
  }, {
    title: 'CAPÍTULO 7 — Armado visual del instrumental',
    content: ['Cómo ordenar una mesa correctamente', 'Distribución eficiente', 'Organización por tiempos quirúrgicos', 'Cómo evitar contaminación cruzada', 'Métodos rápidos de reconocimiento']
  }]
}, {
  title: 'CAPÍTULO 2 — Armado de Mesa e Instrumentación por Cirugía',
  chapters: [{
    title: 'CAPÍTULO 1 — Principios del armado de mesa',
    content: ['Qué debe tener toda mesa quirúrgica', 'Orden lógico del instrumental', 'Cómo anticiparse al cirujano', 'Preparación mental antes de cirugía', 'Seguridad y esterilidad']
  }, {
    title: 'CAPÍTULO 2 — Cirugía general',
    content: ['Mesa para apendicectomía', 'Mesa para hernia', 'Mesa para colecistectomía', 'Instrumental esencial', 'Organización eficiente']
  }, {
    title: 'CAPÍTULO 3 — Traumatología',
    content: ['Instrumental ortopédico básico', 'Separadores específicos', 'Material de osteosíntesis', 'Orden del instrumental', 'Errores comunes']
  }, {
    title: 'CAPÍTULO 4 — Ginecología y obstetricia',
    content: ['Mesa para cesárea', 'Instrumental ginecológico', 'Preparación específica', 'Manejo rápido de materiales']
  }, {
    title: 'CAPÍTULO 5 — Cirugía cardiovascular y torácica',
    content: ['Instrumental especializado', 'Cuidados específicos', 'Preparación avanzada', 'Seguridad intraoperatoria']
  }, {
    title: 'CAPÍTULO 6 — Neurocirugía',
    content: ['Instrumental delicado', 'Organización de precisión', 'Manejo del campo quirúrgico', 'Cómo evitar errores críticos']
  }, {
    title: 'CAPÍTULO 7 — Cirugía laparoscópica',
    content: ['Equipamiento laparoscópico', 'Trocars y ópticas', 'Preparación del sistema', 'Problemas frecuentes']
  }]
}, {
  title: 'CAPÍTULO 3 — Asepsia, Esterilidad y Bioseguridad',
  chapters: [{
    title: 'CAPÍTULO 1 — Fundamentos de asepsia',
    content: ['Qué es asepsia', 'Qué es antisepsia', 'Diferencias clave', 'Cómo evitar contaminación']
  }, {
    title: 'CAPÍTULO 2 — Lavado quirúrgico',
    content: ['Técnica correcta', 'Tiempos adecuados', 'Errores comunes', 'Preparación prequirúrgica']
  }, {
    title: 'CAPÍTULO 3 — Vestimenta estéril',
    content: ['Colocación correcta de guantes', 'Colocación de camisolín', 'Cómo mantener esterilidad', 'Qué hacer si se rompe la técnica']
  }, {
    title: 'CAPÍTULO 4 — Esterilización del instrumental',
    content: ['Métodos de esterilización', 'Autoclave', 'Gas', 'Plasma', 'Cómo controlar esterilidad']
  }, {
    title: 'CAPÍTULO 5 — Manejo del campo estéril',
    content: ['Límites del campo', 'Cómo circular correctamente', 'Qué nunca hacer', 'Prevención de infecciones']
  }, {
    title: 'CAPÍTULO 6 — Bioseguridad hospitalaria',
    content: ['Riesgos biológicos', 'Accidentes cortopunzantes', 'Protocolos de emergencia', 'Manejo de residuos patológicos']
  }, {
    title: 'CAPÍTULO 7 — Errores frecuentes en quirófano',
    content: ['Contaminaciones invisibles', 'Errores de estudiantes', 'Cómo actuar bajo presión', 'Casos reales explicados']
  }]
}, {
  title: 'CAPÍTULO 4 — Rol del Instrumentador Antes, Durante y Después de la Cirugía',
  chapters: [{
    title: 'CAPÍTULO 1 — Preparación preoperatoria',
    content: ['Verificación del paciente', 'Checklist prequirúrgica', 'Material necesario', 'Coordinación con equipo']
  }, {
    title: 'CAPÍTULO 2 — Durante la cirugía',
    content: ['Cómo anticiparse', 'Comunicación efectiva', 'Manejo del estrés', 'Resolución rápida de problemas']
  }, {
    title: 'CAPÍTULO 3 — Tiempos quirúrgicos',
    content: ['Diéresis', 'Hemostasia', 'Exposición', 'Síntesis', 'Cómo cambia el instrumental']
  }, {
    title: 'CAPÍTULO 4 — Conteo quirúrgico',
    content: ['Gasas', 'Agujas', 'Instrumental', 'Protocolos de seguridad', 'Prevención de errores graves']
  }, {
    title: 'CAPÍTULO 5 — Manejo emocional del quirófano',
    content: ['Estrés en cirugía', 'Cómo mantener foco', 'Qué hacer ante presión del equipo', 'Seguridad profesional']
  }, {
    title: 'CAPÍTULO 6 — Postoperatorio',
    content: ['Retiro del instrumental', 'Limpieza', 'Clasificación', 'Reprocesamiento']
  }, {
    title: 'CAPÍTULO 7 — Cómo destacarte como instrumentador',
    content: ['Hábitos de profesionales eficientes', 'Qué observan los cirujanos', 'Cómo ganar seguridad', 'Cómo dejar de sentirte perdido']
  }]
}, {
  title: 'CAPÍTULO 5 — Guía Real para Prácticas Hospitalarias',
  chapters: [{
    title: 'CAPÍTULO 1 — Primer día en quirófano',
    content: ['Qué esperar', 'Cómo comportarse', 'Qué llevar', 'Qué evitar']
  }, {
    title: 'CAPÍTULO 2 — Cómo estudiar para prácticas',
    content: ['Métodos visuales', 'Mapas mentales', 'Reconocimiento rápido', 'Técnicas de memorización útil']
  }, {
    title: 'CAPÍTULO 3 — Qué hacer si no entendés una cirugía',
    content: ['Cómo seguir el procedimiento', 'Cómo observar correctamente', 'Cómo aprender sin bloquearte']
  }, {
    title: 'CAPÍTULO 4 — Errores típicos de estudiantes',
    content: ['Romper esterilidad', 'Entregar mal instrumental', 'Mala organización', 'Cómo corregir rápido']
  }, {
    title: 'CAPÍTULO 5 — Comunicación en quirófano',
    content: ['Cómo hablar con cirujanos', 'Cómo preguntar correctamente', 'Jerarquías hospitalarias', 'Trabajo en equipo']
  }, {
    title: 'CAPÍTULO 6 — Situaciones reales de tensión',
    content: ['Urgencias', 'Emergencias', 'Cirugías largas', 'Cómo mantener control']
  }, {
    title: 'CAPÍTULO 7 — Cómo ganar seguridad profesional',
    content: ['Confianza progresiva', 'Automatización de procesos', 'Desarrollo profesional', 'Mentalidad eficiente']
  }]
}, {
  title: 'CAPÍTULO 6 — Casos Reales y Especialidades Quirúrgicas',
  chapters: [{
    title: 'CAPÍTULO 1 — Cirugía de urgencia',
    content: ['Cómo cambia la dinámica', 'Preparación rápida', 'Prioridades críticas']
  }, {
    title: 'CAPÍTULO 2 — Cirugía pediátrica',
    content: ['Instrumental específico', 'Manejo delicado', 'Diferencias clave']
  }, {
    title: 'CAPÍTULO 3 — Cirugía traumatológica',
    content: ['Casos frecuentes', 'Material protésico', 'Instrumentación específica']
  }, {
    title: 'CAPÍTULO 4 — Cesáreas y obstetricia',
    content: ['Organización rápida', 'Instrumental clave', 'Manejo del tiempo']
  }, {
    title: 'CAPÍTULO 5 — Neurocirugía y alta complejidad',
    content: ['Instrumental delicado', 'Precisión extrema', 'Seguridad avanzada']
  }, {
    title: 'CAPÍTULO 6 — Casos reales explicados paso a paso',
    content: ['Qué pasó', 'Qué salió mal', 'Cómo resolverlo', 'Enseñanzas importantes']
  }, {
    title: 'CAPÍTULO 7 — Simulación de quirófano completo',
    content: ['Preparación total', 'Desarrollo de cirugía', 'Resolución de problemas', 'Checklist final']
  }]
}];
export const ChaptersAccordion: React.FC = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(0);
  const toggleTomo = (index: number) => {
    setOpenTomo(openTomo === index ? null : index);
  };
  return <section className="w-full bg-slate-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-62">
            Lo que vas a recibir:{' '}
            <span className="text-cyan-700" data-id="element-63">6 Capítulos COMPLETOS</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-64">
            Todo el conocimiento práctico estructurado para que lo apliques
            desde el día 1.
          </p>
        </div>

        <div className="space-y-4" data-id="element-65">
          {tomosData.map((tomo, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden transition-all duration-200" data-id="element-66">
              <button onClick={() => toggleTomo(index)} className="w-full flex items-center justify-between p-5 sm:p-6 bg-white hover:bg-slate-50 transition-colors text-left" data-id="element-67">
                <div className="flex items-center gap-4" data-id="element-68">
                  <div className={`p-2 rounded-lg ${openTomo === index ? 'bg-cyan-100 text-cyan-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-69">
                    <BookOpen className="w-6 h-6" data-id="element-70" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-slate-800 pr-4" data-id="element-71">
                    {tomo.title}
                  </h3>
                </div>
                <ChevronDown className={`w-6 h-6 text-slate-400 flex-shrink-0 transition-transform duration-300 ${openTomo === index ? 'rotate-180' : ''}`} data-id="element-72" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openTomo === index ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-73">
                <div className="p-5 sm:p-6 pt-0 border-t border-slate-100 bg-slate-50/50" data-id="element-74">
                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-75">
                    {tomo.chapters.map((chapter, cIndex) => <div key={cIndex} className="bg-white p-4 rounded-lg border border-slate-100 shadow-sm" data-id="element-76">
                        <h4 className="font-bold text-cyan-800 mb-3 text-sm border-b border-slate-100 pb-2" data-id="element-77">
                          {chapter.title}
                        </h4>
                        <ul className="space-y-2" data-id="element-78">
                          {chapter.content.map((item, iIndex) => <li key={iIndex} className="flex items-start gap-2 text-sm text-slate-600" data-id="element-79">
                              <span className="text-cyan-500 mt-0.5" data-id="element-80">•</span>
                              <span data-id="element-81">{item}</span>
                            </li>)}
                        </ul>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};